'use client'

import React from 'react'
import type { ReactNode } from 'react'

export interface CardProps {
  children: ReactNode
  className?: string
  padding?: number | string
  paddingX?: number | string
  paddingY?: number | string
  border?: number | string
  borderRadius?: number | string
  background?: string
  display?: string
  alignItems?: string
  justifyContent?: string
  gap?: number | string
  width?: string | number
  height?: string | number
  style?: React.CSSProperties
  onClick?: () => void
}

export default function Card({
  children,
  className = '',
  border = 'none',
  borderRadius = '6px',
  background = '#FFF',
  display = 'flex',
  alignItems = 'center',
  justifyContent = 'center',
  gap = '5px',
  width,
  height,
  style,
  ...props
}: CardProps) {
  const paddingStyle = {
    border: border === 'none' ? 'none' : border,
    borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
    backgroundColor: background,
    display,
    alignItems,
    justifyContent,
    gap: typeof gap === 'number' ? `${gap}px` : gap,
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    ...style,
  }

  return (
    <div className={`card ${className} p-3`} style={paddingStyle} {...props}>
      {children}
    </div>
  )
}
